import getProductSummaries from "../../api/productSummariesApi";
import getClientStockPrice from "../../api/clientStockPriceApi";
import getRuntimeConstants from "../../runtimeConstants";
import { summariesAndStockPriceVariantMapper } from "../../../mappers/summariesAndStockPriceVariant";
import { recommendedProductMapper } from "../../../mappers/recommendedProduct";
import { logError, ERROR_TYPE } from "../../utils/newRelicLogger";

export const getFullImageUrl = (productUrl) => {
  return productUrl.startsWith("http") ? productUrl : `https://${productUrl}`;
};

const recommendedOutfitsProductsData = (
  stockPriceData,
  productSummariesData,
) => {
  if (!stockPriceData?.length || !productSummariesData?.length) {
    return [];
  }

  const stockPriceAndSummariesData = stockPriceData.map((stockData) => {
    const summariesData = productSummariesData.find(
      (sum) => sum.id === stockData.productId,
    );

    const variants = stockData.variants?.length ? stockData.variants : [];
    const mappedVariants = variants.map((stockPriceVariant) => {
      if (!stockPriceVariant) {
        return [];
      }

      const summariesVariant = summariesData?.variants?.find(
        (v) => v.id === stockPriceVariant.id,
      );

      if (!summariesVariant) {
        return [];
      }

      return summariesAndStockPriceVariantMapper(
        stockPriceVariant,
        summariesVariant,
      );
    });

    return recommendedProductMapper(stockData, summariesData, mappedVariants);
  });

  return stockPriceAndSummariesData;
};

const fetchStockPriceData = async (recommendedOutfits, storeCode) => {
  try {
    return await getClientStockPrice({
      products: recommendedOutfits,
      storeCode,
    });
  } catch (error) {
    logError(ERROR_TYPE.StockPriceError, {
      action: "getClientStockPrice",
      caller: "getClientStockPriceForRecommendedOutfits",
      apiName: "stockPrice",
      message: error.message,
    });
    return null;
  }
};

const fetchProductSummariesData = async (recommendedOutfits) => {
  try {
    return await getProductSummaries(recommendedOutfits);
  } catch (error) {
    logError(ERROR_TYPE.UserActionFailed, {
      action: "getProductSummaries",
      caller: "getProductSummeriesForRecommendedOutfits",
      apiName: "productSummaries",
      message: error.message,
    });
    return null;
  }
};

export const getSummariesAndStockData = async ({ recommendedOutfits }) => {
  const { storeCode } = getRuntimeConstants();

  const stockPriceData = await fetchStockPriceData(
    recommendedOutfits,
    storeCode,
  );

  if (!stockPriceData) {
    return [];
  }

  const productSummariesData =
    await fetchProductSummariesData(recommendedOutfits);

  if (!productSummariesData) {
    return [];
  }

  const recommendedOutfitsProducts = recommendedOutfitsProductsData(
    stockPriceData,
    productSummariesData,
  );

  return recommendedOutfitsProducts;
};
